import moment from 'moment'
import sv_moment from 'moment/locale/sv'

export const format = (value, n, x, s, c) => {
  n = (n === undefined ? 2 : n)
  x = (x === undefined ? 3 : x)
  s = (s === undefined ? ' ' : s)
  c = (c === undefined ? ',' : c)

  var re = '\\d(?=(\\d{' + x + '})+' + (n > 0 ? '\\D' : '$') + ')',
    num = value.toFixed(Math.max(0, ~~n))

  return (c ? num.replace('.', c) : num).replace(new RegExp(re, 'g'), '$&' + s)
}

export const isMobile = () => {
  let check
  // eslint-disable-next-line
  (a => {
    if (/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(a) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\/-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\/-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\/-(n|u)|c55\/|capi|ccwa|cdm\/-|cell|chtm|cldc|cmd\/-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\/-s|devi|dica|dmob|do(c|p)o|ds(12|\/-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\/-|_)|g1 u|g560|gene|gf\/-5|g\/-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\/-(m|p|t)|hei\/-|hi(pt|ta)|hp( i|ip)|hs\/-c|ht(c(\/-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\/-(20|go|ma)|i230|iac( |\/-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\/-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\/-[a-w])|libw|lynx|m1\/-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\/-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\/-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\/-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\/-([1-8]|c))|phil|pire|pl(ay|uc)|pn\/-2|po(ck|rt|se)|prox|psio|pt\/-g|qa\/-a|qc(07|12|21|32|60|\/-[2-7]|i\/-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\/-|oo|p\/-)|sdk\/|se(c(\/-|0|1)|47|mc|nd|ri)|sgh\/-|shar|sie(\/-|m)|sk\/-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\/-|v\/-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\/-|tdg\/-|tel(i|m)|tim\/-|t\/-mo|to(pl|sh)|ts(70|m\/-|m3|m5)|tx\/-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\/-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\/-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\/-|your|zeto|zte\/-/i.test(a.substr(0, 4)))
      check = true
  })(navigator.userAgent || navigator.vendor || window.opera)

  return check || false
}

export const isIOS = () => {
  let check
  const agent = navigator.userAgent || navigator.vendor || window.opera

  if (/(ip(hone|od))|iOS/i.test(agent))
    check = true

  return check || false
}

/**
 * Converts an array of strings to a good URL by concatenating the strings with hyphens,
 * replacing non-alphanumeric characters with hyphens, replacing Swedish characters with
 * their ASCII equivalents, and converting the resulting string to lowercase.
 * 
 * @param {string[]} texts - The array of strings to convert to a URL.
 * @returns {string} The converted URL.
 */
export const urlName = (texts) => {
  const replacedText = texts
    .replace(/[^a-zA-Z0-9ÄÅÖäåö]+/g, '-')
    .replace(/[ÄÅ]/g, 'a')
    .replace(/[Öö]/g, 'o')
  const trimmedText = replacedText.replace(/^-+|-+$/g, '')
  const lowercasedText = trimmedText.toLowerCase()

  return lowercasedText
}

export const getWeekDate = date => {
  moment.locale('sv')
  const weekNr = moment(date).week()
  const year = moment(date).year()
  const weekstring = `${year}-W${weekNr}`

  return weekstring
}

export const weekInputCalc = (date) => {
  let wholeDate = moment(date).format('YYYY-MM-DD')
  let month = Number(moment(date).format('MM'))
  let week = moment(date).format('WW')

  if (month === 12 && week === '01') {
    let correctDate = moment(wholeDate).add(1, 'year')
    let year = correctDate.year()
    month = 1

    var datezz = year + '-W' + week
    return datezz
  } else {
    return moment(date).format('YYYY') + '-W' + moment(date).format('WW')
  }
}

export const getCookie = (a) => {
  var b = document.cookie.match('(^|;)\\s*' + a + '\\s*=\\s*([^;]+)')
  return b ? b.pop() : ''
}

export const setCookie = (cname, cvalue, exdays) => {
  var d = new Date()
  d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000))
  var expires = 'expires=' + d.toUTCString()
  document.cookie = cname + '=' + cvalue + ';' + expires + ';path=/'
}

export const testLocalstorage = () => {
  var mod = 'modernizr'
  try {
    localStorage.setItem(mod, mod)
    localStorage.removeItem(mod)
    return true
  } catch (e) {
    return false
  }
}

export const checkPathName = (path) => {
  if (!path) return false

  const userPaths = [
    'userprofile',
    'deliveryaddresses',
    'orders',
    'invoices'
  ]

  if (path.charAt(0) === '/') {
    path = path.substring(1)
  }

  const processedPath = userPaths.find(uPath => uPath === path)
  return processedPath ? true : false
}

export const checkWebshopPathName = (path) => {
  if (!path) return false

  const userPaths = [
    'userprofile',
    'deliveryaddresses',
    'orders',
    'invoices',
    'products',
    'article'
  ]

  if (path.charAt(0) === '/') {
    path = path.substring(1)
  }

  const processedPath = userPaths.find(uPath => uPath === path)
  return processedPath ? true : false
}

export const formatDeliveryDate = (estimatedDeliveryDate) => {
  moment.locale('sv', sv_moment)
  return moment(estimatedDeliveryDate).format('MMMM')
}

/**
 * The URL of an image served by the store's API. The .jpg extension is what lets Cloudflare
 * cache the image at the edge; the response keeps the image's own content type.
 *
 * @param {string} endpoint - The API's image route, such as 'ArticleThumbnail'.
 * @param {number} id - The image id.
 * @returns {string} The image URL.
 */
export const apiImageUrl = (endpoint, id) => `${process.env.REACT_APP_API_URL}/api/${endpoint}/${id}.jpg`
